import { render, staticRenderFns } from "./TodasRedesSociais.vue?vue&type=template&id=ce5452d0&scoped=true"
import script from "./TodasRedesSociais.vue?vue&type=script&lang=js"
export * from "./TodasRedesSociais.vue?vue&type=script&lang=js"
import style0 from "./TodasRedesSociais.vue?vue&type=style&index=0&id=ce5452d0&prod&lang=css"
import style1 from "./TodasRedesSociais.vue?vue&type=style&index=1&id=ce5452d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5452d0",
  null
  
)

export default component.exports